(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxNetworkSettings(
    TenantListService, $http, toastr, $filter
    ) {
    return {
      restrict: 'EA',
      scope: {
        me: '=me',
        isThisSiteMine: '=isThisSiteMine',
        network: '=context',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/sites/networkSettings/networkSettings.template.html',
      link: function(scope) {

        scope.tenantListService = TenantListService;

        scope.networkCopy = angular.copy(scope.network);

        (function() {
          // init
        })();

        scope.saveNetworkSettings = function () {
          var patch = [];

          if (scope.networkCopy.clientMigratePrintQueues !== scope.network.clientMigratePrintQueues) {
            var patchObject = {
              op: 'replace',
              path: '/clientMigratePrintQueues',
              value: scope.network.clientMigratePrintQueues
            }
            patch.push(patchObject);
          }

          if (scope.networkCopy.airprint !== scope.network.airprint) {
            var patchObject = {
              op: 'replace',
              path: '/airprint',
              value: scope.network.clientMigratePrintQueues
            }
          }
          var url = scope.network._links.self.href;
          if (patch.length > 0) {
            $http.patch(url, patch).then(function(response) {
              toastr.success($filter("translate")("ChagesSaved"))
            }).catch(function(error){
              toastr.error($filter("translate")("ERROR"))
            });
          }
          scope.callback();
        }

      }
    };
  }

  pxNetworkSettings.$inject = ['TenantListService', '$http', 'toastr', '$filter'];

  angular
    .module('printix-admin')
    .directive('pxNetworkSettings', pxNetworkSettings);

})();
